import { useState, useCallback, useEffect } from 'react';

/**
 *
 * @param {() => Promise<T>} asyncFn The function to execute
 * @param {boolean} immediate If its true the function will be executed immediately. Default true
 * @returns {{status: 'idle' | 'pending' | 'resolved' | 'rejected', data: T, error, executeFn: () => Promise<Void>}}
 */
const useAsync = (asyncFn, immediate = true) => {
  const [status, setStatus] = useState('idle');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const executeFn = useCallback(async () => {
    setStatus('pending');

    try {
      const response = await asyncFn();

      setData(response);
      setStatus('resolved');
    } catch (e) {
      setError(e);
      setStatus('rejected');
    }
  }, [asyncFn]);

  useEffect(() => {
    if (immediate) {
      executeFn();
    }
  }, [executeFn, immediate]);

  return { status, data, error, executeFn };
};

export default useAsync;
